import Decimal from 'decimal.js';

import { Currency } from 'src/shared/enum/Currency';

import { PaymentPlanDto } from '../../paymentPlanService/dto/PaymentPlanDto';
import { mapPaymentPlanResponse } from '../../paymentPlanService/mappers';
import { RoomInfoResponse } from '../types';

export interface RoomImagery {
    thumbnailUrl: string;
    cdnUrl: string;
}

export class RoomInfoDto {
    readonly unitType: string;

    readonly floor: number;

    readonly size: number;

    readonly basePrice: Decimal;

    readonly currency: Currency;

    readonly minNumOfStudents: number;

    readonly maxNumOfStudents: number;

    readonly imagery: RoomImagery[];

    // e.g. { 1: { Annual: PaymentPlanDto, '2 Instalments': PaymentPlanDto } }
    readonly paymentOptions: Record<number, Record<string, PaymentPlanDto>>;

    constructor(rawRoomInfo: RoomInfoResponse) {
        this.unitType = rawRoomInfo.unit_type;
        this.floor = rawRoomInfo.floor;
        this.size = rawRoomInfo.size;
        this.basePrice = new Decimal(rawRoomInfo.base_price);
        this.currency = rawRoomInfo.currency;
        this.minNumOfStudents = rawRoomInfo.min_num_of_students;
        this.maxNumOfStudents = rawRoomInfo.max_num_of_students;
        this.imagery = (rawRoomInfo.imagery ?? []).map((image) => ({
            thumbnailUrl: image.thumbnail_url,
            cdnUrl: image.cdn_url,
        }));
        this.paymentOptions = Object.fromEntries(
            Object.entries(rawRoomInfo.paymentOptions).map(([students, paymentPlans]) => [
                Number(students),
                Object.fromEntries(
                    Object.entries(paymentPlans).map(([instalmentType, paymentPlan]) => [
                        instalmentType,
                        mapPaymentPlanResponse(paymentPlan),
                    ])
                ),
            ])
        );
    }
}
